import type { CSSProperties, InputHTMLAttributes } from "react";
import { Icon } from "../icon/Icon";

export interface CheckboxProps extends Omit<InputHTMLAttributes<HTMLInputElement>, "type"> {
  checked?: boolean;
  indeterminate?: boolean;
  disabled?: boolean;
  label?: string;
}

export function Checkbox({
  checked = false,
  indeterminate = false,
  disabled = false,
  label,
  onChange,
  style,
  ...rest
}: CheckboxProps) {
  const on = checked || indeterminate;
  const box: CSSProperties = {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: 22,
    height: 22,
    flex: "none",
    borderRadius: "var(--radius-xs)",
    background: on ? (disabled ? "var(--interaction-disable)" : "var(--primary-normal)") : "var(--background-normal-normal)",
    boxShadow: on
      ? "none"
      : `inset 0 0 0 1.5px ${disabled ? "var(--line-normal-alternative)" : "var(--line-normal-strong)"}`,
    color: "var(--static-white)",
    transition: "background var(--duration-fast) var(--ease-standard)",
  };
  return (
    <label
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 8,
        cursor: disabled ? "not-allowed" : "pointer",
        fontFamily: "var(--font-sans)",
        opacity: disabled && !on ? 0.6 : 1,
        ...style,
      }}
    >
      <input
        type="checkbox"
        checked={checked}
        disabled={disabled}
        onChange={onChange}
        style={{ position: "absolute", opacity: 0, width: 0, height: 0 }}
        {...rest}
      />
      <span style={box}>
        {indeterminate ? <Icon name="minus" size={16} /> : on ? <Icon name="check" size={16} /> : null}
      </span>
      {label && (
        <span
          style={{
            fontSize: "var(--font-size-body-2)",
            lineHeight: "var(--line-height-body-2)",
            color: "var(--label-normal)",
          }}
        >
          {label}
        </span>
      )}
    </label>
  );
}

export default Checkbox;
